<template>
  <News_index></News_index>
  <News_page></News_page>
  <br>
  <Footer/>
</template>

<script>
import News_index from "@/components/CN/news/News_index";
import News_page from "@/components/CN/news/News_page";
import Footer from "@/components/CN/Footer";
import Header from '../../components/CN/Header'
export default {
  name: 'News',
  components: {Footer, News_index, News_page, Header},
}

</script>